import * as React from 'react';
import { jsx, css } from '@emotion/react';
import type { BaseAnswerType } from '../../../../views/types';
import type { SectionsPropsType } from '../../../../sections/types';
import { renderAdvisorMessage } from '../../../../views/AdvisorMessage';
import { renderUserMessage } from '../../../../views/UserMessage';
import { renderSimpleButtonGroup } from '../../../../views/SimpleButtonGroup';
import { renderSingleImage } from '../../../../views/SingleImage';
import { buildAnswers, buildUserAnswerMessage } from '../../../../sections/utils';

import RoofLeakageExamplePngPath from 'Images/me/pages/guest/proposals/new/roof_leakage/example.png'
import RoofLeakageExampleWebPPath from 'Images/me/pages/guest/proposals/new/roof_leakage/example.webp'

const SECTION_KEY_NAME = 'roofLeakage';
const PARAM_NAME = SECTION_KEY_NAME;
const GA_EVENT_NAME = 'roofLeakage';

export const roofLeakageSection = async (props: SectionsPropsType) => {
  const { userAnswers, commonAnswerHandler } = props;
  const answers: BaseAnswerType[] = [
    { value: '雨の日に水滴が落ちます', textContents: (<>雨の日に<br />水滴が落ちる</>) },
    { value: '天井にシミがあります', textContents: (<>天井に<br />シミがある</>) },
    { value: 'まったくない', textContents: (<>まったく<br />ない</>) },
  ];
  const answerHandler = (event: React.MouseEvent<HTMLButtonElement>): void => {
    const { textContent, value } = event.currentTarget;

    commonAnswerHandler(PARAM_NAME, textContent || '');

    userAnswers.push({
      keyName: SECTION_KEY_NAME,
      paramName: PARAM_NAME,
      question: '屋根は雨漏りしているか',
      answer: textContent || '',
      value: value || '',
    });
  };

  // アドバイザーの吹き出し
  await renderSingleImage({
    ...props,
    keyName: SECTION_KEY_NAME,
    imagePaths: {
      imagePath: RoofLeakageExamplePngPath,
      webp: RoofLeakageExampleWebPPath,
    },
    altText: '屋根の雨漏り',
    viewWidth: {
      pc: 350,
      mobile: 320,
    },
    imageRatio: { width: 350, height: 222 },
    withWebp: true,
  });

  await renderAdvisorMessage({
    ...props,
    keyName: SECTION_KEY_NAME,
    messageElement: (
      <>
        雨漏りや漏水の症状はありますか？
      </>
    ),
  });

  // 回答ボタン表示
  const answer = await renderSimpleButtonGroup({
    ...props,
    keyName: SECTION_KEY_NAME,
    answers: buildAnswers({
      keyName: SECTION_KEY_NAME,
      answers,
      answerHandler,
      gaEventName: GA_EVENT_NAME,
    }),
  });

  // ユーザーの吹き出し
  await renderUserMessage({
    ...props,
    keyName: SECTION_KEY_NAME,
    messageElement: buildUserAnswerMessage(answer.value),
  });

  // 回答内容を返却する
  return answer;
};
